export * from './miniapp-activity-center';
